'use strict';

import {
    DOMUtils,
    HttpRequest
} from "./Utils";
import {
    getAttr,
    resetAttr,
    setAttr
} from "./options";
import {
    cookieEnum,
    getCookie,
    removeCookie,
    setCookie
} from "./cookie.js";

import {
    home,
    loginByToken
} from "./home.js";
import {
    liste,
} from "./liste";
import {
    impressum
} from "./impressum.js";
import {
    initNavButtons
} from "./navButtons.js"


// webpack workaround
var jsPagesHandler = {
    "home": home,
    "liste": liste,
    "impressum": impressum
};

var screenHandle = null;

/**
 * Loads a new page into the dedicated container
 * This function also executes the appropriate data-on-load/o
 */
async function loadPage() {

    const page = window.location.hash.substr(1).replace(/-/g, "/");

    var html = document.getElementById(`t-${page}`);
    // console.log(html);
    if (html) {
        html = html.innerHTML;
    } else {
        console.log("loadPage failed! ", page);
        return;
    }

    // Unload last page
    if (screenHandle) {
        screenHandle.close();
        screenHandle = null;
    }

    // console.log(html);

    //Compute the height of the new window

    const contentDummy = document.getElementById("content-dummy");
    contentDummy.innerHTML = html;
    // const newheight = contentDummy.clientHeight + 32;
    const element = contentDummy.firstElementChild;

    var screen = element.dataset.initClass;

    document.getElementById("content-main").innerHTML = html;

    contentDummy.innerHTML = "";

    if (screen && screen != "") {
        screenHandle = jsPagesHandler[screen];

        if (screenHandle !== undefined) {
            docReady(() => {
                screenHandle.start();
            });
        } else {
            console.log("screenHandle not defined in jsPagesHandler: ", screen);
        }
    }
}



function docReady(fn) {
    // see if DOM is already available
    if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
    ) {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

async function startup() {
    initNavButtons();

    const queryString = window.location.search;
    if (queryString) {
        const urlParams = new URLSearchParams(queryString);
        const token = urlParams.get("vertok");
        if (token) {
            // site-access by token-link => one-time usage token
            setCookie(cookieEnum.token, token, 1);
            window.history.pushState({}, document.title, "/" + "index.html");
        }
    }

    if (getCookie(cookieEnum.token)) {
        loginByToken();
    } else {
        resetAttr();
        window.location = "#home";
    }

    // This function will detect any anchor change
    // on the local page, so can use this to load our 
    // pages
    window.onhashchange = loadPage;
    loadPage();
}


startup();